/**
 * UK Bank Holidays (England & Wales) — rolling 12-month list.
 * Updated manually; backend will eventually serve these via API.
 * Source: https://www.gov.uk/bank-holidays
 */

const UK_BANK_HOLIDAYS_2026 = [
    { date: '2026-01-01', name: "New Year's Day" },
    { date: '2026-04-03', name: 'Good Friday' },
    { date: '2026-04-06', name: 'Easter Monday' },
    { date: '2026-05-04', name: 'Early May Bank Holiday' },
    { date: '2026-05-25', name: 'Spring Bank Holiday' },
    { date: '2026-08-31', name: 'Summer Bank Holiday' },
    { date: '2026-12-25', name: 'Christmas Day' },
    { date: '2026-12-28', name: 'Boxing Day (substitute)' },
];

const UK_BANK_HOLIDAYS_2027 = [
    { date: '2027-01-01', name: "New Year's Day" },
    { date: '2027-03-26', name: 'Good Friday' },
    { date: '2027-03-29', name: 'Easter Monday' },
    { date: '2027-05-03', name: 'Early May Bank Holiday' },
    { date: '2027-05-31', name: 'Spring Bank Holiday' },
    { date: '2027-08-30', name: 'Summer Bank Holiday' },
    { date: '2027-12-27', name: 'Christmas Day (substitute)' },
    { date: '2027-12-28', name: 'Boxing Day (substitute)' },
];

/**
 * Returns upcoming UK bank holidays from today, sorted by date.
 * @returns {Array<{date: string, name: string}>}
 */
export function getUpcomingBankHolidays() {
    const today = new Date().toISOString().slice(0, 10);
    return [...UK_BANK_HOLIDAYS_2026, ...UK_BANK_HOLIDAYS_2027]
        .filter((h) => h.date >= today)
        .sort((a, b) => a.date.localeCompare(b.date));
}
